import { Request } from "./HttpService";

export const DashboardService = {
  getCardDocOnlineInterview: function (pageSize, pageNumber, searchObject) {
    let url = `vitae/Dashboard/submitedDocOnline/${pageSize}/${pageNumber}`;

    if (Object.keys(searchObject).length > 0) {
      url = `${url}?`;
      for (let key in searchObject) url = `${url}${key}=${searchObject[key]}&`;
    }

    return Request(url, "GET");
  },
  getDashboard(stardate, endDate, username) {
    return Request(
      `vitae/Dashboard?startdate=${stardate}&endDate=${endDate}&username=${username}`,
      "GET"
    );
  },
  getDashboardParameters() {
    return Request(`vitae/Dashboard/parameters`, "GET");
  },
  getDetailsUrls(precandidateId) {
    return Request(`vitae/Dashboard/hasinterview/${precandidateId}`, "GET");
  },

  getInterviewIdByEmail(email) {
    return Request(`vitae/interview/byemail/${email}`, "GET");
  }
};
